import React from "react";

const TONE = {
  strong: { ring: "#059669", pill: "bg-emerald-50 text-emerald-700 border-emerald-200", label: "Strong fit" },
  possible: { ring: "#D97706", pill: "bg-amber-50 text-amber-700 border-amber-200", label: "Possible fit" },
  stretch: { ring: "#E11D48", pill: "bg-rose-50 text-rose-600 border-rose-200", label: "Stretch" },
  below: { ring: "#64748B", pill: "bg-slate-100 text-slate-600 border-slate-300", label: "Below your level" },
};

export const FitPill = ({ fit, testId }) => {
  if (!fit) return null;
  const tone = fit.below_level ? TONE.below : TONE[fit.verdict] || TONE.stretch;
  return <span className={`rounded-full border px-2.5 py-0.5 text-[10px] font-semibold ${tone.pill}`} data-testid={testId}>{tone.label}</span>;
};

export const FitRing = ({ score, verdict, belowLevel = false, size = 76, testId }) => {
  const tone = belowLevel ? TONE.below : TONE[verdict] || TONE.stretch;
  const r = 15.5;
  const circumference = 2 * Math.PI * r;
  return (
    <div className="relative shrink-0" style={{ width: size, height: size }} data-testid={testId}>
      <svg viewBox="0 0 36 36" className="-rotate-90" style={{ width: size, height: size }}>
        <circle cx="18" cy="18" r={r} fill="none" stroke="#EEF2F7" strokeWidth="3.4" />
        <circle cx="18" cy="18" r={r} fill="none" stroke={tone.ring} strokeWidth="3.4" strokeLinecap="round"
          strokeDasharray={`${(Math.max(0, Math.min(100, score)) / 100) * circumference} ${circumference}`}
          style={{ transition: "stroke-dasharray 0.8s cubic-bezier(0.22,1,0.36,1)" }} />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center leading-none">
        <span className="num-display text-base">{score}</span>
        <span className="text-[8px] font-mono uppercase tracking-wider text-slate-500">of 100</span>
      </div>
    </div>
  );
};

export const FitBreakdown = ({ fit, note }) => (
  <div className="card-soft p-5" data-testid="fit-breakdown">
    <h3 className="text-base font-bold text-slate-900">How your fit score is built</h3>
    <p className="mt-1 text-xs text-slate-500">{note || "Four factors, each with a fixed share of the 100 points."}</p>
    <div className="mt-4 space-y-3">
      {fit.breakdown.map((row) => (
        <div key={row.factor} data-testid={`fit-factor-${row.factor.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
          <div className="flex items-baseline justify-between gap-3">
            <p className="text-sm text-slate-800">{row.factor}</p>
            <p className="num-display text-xs text-slate-600">{row.points} / {row.max}</p>
          </div>
          <div className="mt-1.5 h-2 w-full rounded-full bg-slate-100">
            <div className="h-2 rounded-full" style={{ width: `${(row.points / row.max) * 100}%`, background: row.points / row.max >= 0.66 ? "#059669" : row.points / row.max >= 0.33 ? "#D97706" : "#E11D48", transition: "width 0.7s ease" }} />
          </div>
          <p className="mt-1 text-[11px] text-slate-500">{row.note}</p>
        </div>
      ))}
    </div>
  </div>
);
